import { connect } from 'react-redux';
import ShiftRow from './ShiftRow';
import { sortShiftRequest, updateShiftFlag } from '../../../../../store/actions/shifts.actions';

const mapDispatchToProps = { sortShiftRequest, updateFlag: updateShiftFlag };

export default connect(null, mapDispatchToProps)(ShiftRow);